import { Address } from '@/models';

export class SponsorInfo {
  constructor(
  public sponsorId: number = 0,
  public sponsorNumber: string = '',
  public sponsorName: string = '',
  public address: Address | undefined = undefined) {
  }
}
